<template>
    <section class="is-relative">
        <h3 class="stepper__content__header">{{ $t('WHERE_DID_YOU_GET_BRASTER_FROM') }}</h3>

        <div class="content__wrapper flex-center">
            <div class="header--description box-shadow box-shadow--arrow-left">
                {{ $t('IF_YOU_BOUGHT_FOR_YOURSELF') }}
            </div>
        </div>

        <div class="flex-center flex-row">
            <label class="fake-label">
                <input class="custom-input" type="radio" value="true" name="s1q1Val" v-model="s1q1Val" />
                <span class="input-container">{{ $t('BOUGHT') }}</span>
                <span class="checkmark"></span>
            </label>
            <label class="fake-label">
                <input
                    class="custom-input"
                    type="radio"
                    value="other"
                    name="s1q1Val"
                    @click="goNext"
                    v-model="s1q1Val"
                />
                <span class="input-container">{{ $t('GOT') }}</span>
                <span class="checkmark"></span>
            </label>
            <label class="fake-label">
                <input
                    class="custom-input"
                    type="radio"
                    value="false"
                    name="s1q1Val"
                    @click="goNext"
                    v-model="s1q1Val"
                />
                <span class="input-container">{{ $t('REALIZE_EXAMINATION_0') }}</span>
                <span class="checkmark"></span>
            </label>
        </div>

        <div v-if="s1q1Val === 'true'" class="flex-center flex-row mt-3">
            <label class="fake-label">
                <input
                    class="custom-input"
                    type="radio"
                    value="true"
                    name="s1q1Val"
                    @click="goNext"
                    v-model="s1q1ValAdditional"
                />
                <span class="input-container">{{ $t('JUST_FOR_ME') }}</span>
                <span class="checkmark"></span>
            </label>
            <label class="fake-label">
                <input
                    class="custom-input"
                    type="radio"
                    value="other"
                    name="s1q1Val"
                    @click="goNext"
                    v-model="s1q1ValAdditional"
                />
                <span class="input-container">{{ $t('FOR_ME_AND_WOMAN') }}</span>
                <span class="checkmark"></span>
            </label>
            <label class="fake-label">
                <input
                    class="custom-input"
                    type="radio"
                    value="false"
                    name="s1q1Val"
                    @click="buyForWomen"
                    v-model="s1q1ValAdditional"
                />
                <span class="input-container">{{ $t('FOR_WOMAN') }}</span>
                <span class="checkmark"></span>
            </label>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'survey-step1-q1',
    data() {
        return {
            s1q1Val: '',
            s1q1ValAdditional: '',
        };
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        goNext() {
            this.$store.commit('STATE_SURVEY', { activeStepper: 2 });
        },
        buyForWomen() {
            this.updateUserSurvey({ ...this.user.patient.survey, completionStage: 'BUY_FOR_WOMEN' }).then(() =>
                this.$router.push('/moje-zakupy'),
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.header--description {
    color: #706c69;
    font-size: 14px;
    padding: 10px;
    border: 1px solid #ede8e4;
    float: left;
    margin-bottom: 30px;
    display: block;
    clear: both;
    position: absolute;
    top: 15px;
    right: 30px;
    width: 50%;
}

@media (max-width: 992px) {
    .header--description {
        position: relative;
        top: 0;
        right: 0;
        width: 100%;

        &:before,
        &:after {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// survey-step1-q1.vue?ee32fe9a